/**
 * Equality for the fleet filter contract's C37 ("Apply with nothing staged is not a refetch").
 * Arrays of strings compare as SETS: ticking A then B and ticking B then A stage the same filter,
 * and must not read as a change. Objects compare key by key, order-insensitively.
 */
export function sameFilterValue(a: unknown, b: unknown): boolean {
  return JSON.stringify(normalize(a)) === JSON.stringify(normalize(b));
}

function normalize(v: unknown): unknown {
  if (Array.isArray(v)) {
    const items: unknown[] = v.map(normalize);
    return items.every((x): x is string => typeof x === 'string') ? [...items].sort() : items;
  }
  if (v !== null && typeof v === 'object') {
    const entries = Object.entries(v).sort(([a], [b]) => a.localeCompare(b));
    return Object.fromEntries(entries.map(([k, val]) => [k, normalize(val)]));
  }
  return v;
}
